import axios from 'axios'
import { getRouteAsidePoi } from '@/api/poi'
import { getFuelPrice } from '@/views/map/components/trip-plan-v2/components/poi-along-route/tools'
// import asidePoiPointsResample from "@/store/modules/map/tools/aside-poi-points-resample";

const CancelToken = axios.CancelToken
const state = {
  namespaced: true,
  state: {
    centerPosition: {}, // 地图的中心点经纬度，{ lat: null, lng: null }
    showMarker: false, // 路线上是否展示沿途poi
    axiosToken: {}, // axios 请求token，方便取消请求
    activePointInfo: {}, // 地图上选中点的信息
    mapVisible: true, // 是否处于map页面
    mapControlsDisabled: false, // 地图上的控件是否禁用
    showCardPopup: 0,
    poiOnRoute: [],
    filteredPoiOnRoute: [],
    showLoad: false,
    showDriver: false,
    showFuel: false,
    circleHidden: false,
    activeAsidePoi: null,
    selectedTab: { label: 'All', value: 'All Places'},
    fuelPriceMap: {},
    parkingStatusMap: {},
    weightStationStatusMap: {},
    alonePoiRouteId: null,
    aloneRouteId: null,
  },
  mutations: {
    SET_SHOW_CARD_POPUP(state, status) {
      state.showCardPopup = status
    },
    SET_PARING_STATUS_MAP(state, map) {
      state.parkingStatusMap = map
    },
    SET_ALONE_ROUTE_ID(state, id) {
      state.aloneRouteId = id
    },
    SET_ALONE_POI_ROUTE(state, id) {
      state.alonePoiRouteId = id
    },
    SET_WEIGHT_STATION_STATUS_MAP(state, map) {
      state.weightStationStatusMap = map
    },
    SET_FUEL_PRICE_MAP(state, map) {
      state.fuelPriceMap = map
    },
    SET_SELECTED_TAB(state, tab) {
      state.selectedTab = tab
    },
    SET_MAP_AXIOS_TOKEN(state, tokens) {
      state.axiosToken = tokens
    },
    SET_SHOW_MARKER_STATUS(state, status) {
      state.showMarker = status
    },
    SET_CERTER_POSITION(state, position) {
      state.centerPosition = position
    },
    SET_ACTIVE_POINT_INFO(state, info) {
      state.activePointInfo = info
    },
    SET_MAP_VISIBLE(state, status) {
      state.mapVisible = status
    },
    SET_MAP_CONTROLS_DISABLED(state, status) {
      state.mapControlsDisabled = status
    },
    SET_POI_ON_ROUTE(state, payload) {
      state.poiOnRoute = payload;
    },
    SET_FILTERED_POI_ON_ROUTE(state, payload) {
      state.filteredPoiOnRoute = payload;
    },
    SET_SHOW_LOAD(state, status) {
      state.showLoad = status
    },
    SET_SHOW_DRIVER(state, status) {
      state.showDriver = status
    },
    SET_SHOW_FUEL(state, status) {
      state.showFuel = status
    },
    SET_CIRCLE_HIDDEN(state, status) {
      state.circleHidden = status
    },
    SET_ACTIVE_ASIDER_POI(state, info) {
      state.activeAsidePoi = info
    }
  },
  actions: {
    showCardPopup({state, commit}) {
      commit('SET_SHOW_CARD_POPUP', state.showCardPopup + 1)
    },
    calculateRouteAsidePoi({ dispatch }, { filterBasis, filterLabels, points, startPoint }) {
      // 取消未完成的请求
      // if (state.axiosToken.calculateRouteAsidePoiSource) {
      //   state.axiosToken.calculateRouteAsidePoiSource.cancel('cancel request')
      // }

      // 创建新的请求token
      let source = CancelToken.source()
      // dispatch('updateMapAxiosToken', { tokens: { calculateRouteAsidePoiSource: source } })

      return new Promise((resole, reject) => {
        const { topLabel } = filterLabels
        let params = {
          placeType: filterBasis,
          points: points.map(item => ([item.lat, item.lng])),
        }
        if(startPoint) {
          params.startPoint =[startPoint.lat, startPoint.lng]
        }
        getRouteAsidePoi(params, source.token).then(
          result => {
            // 删除请求token
            dispatch('updateMapAxiosToken', { tokens: { calculateRouteAsidePoiSource: null } })
            try {
              let points = result.res.data.data.map(item => Object.assign(item, { pointType: 'poi', pointId: item.ident }))
              if (topLabel === 'Parking Availability') {
                points = points.filter(val => val.overnightParking)
              }
              resole(points)
            } catch (error) {
              reject(error)
            }
          },
          ({ error }) => {
            // 删除请求token
            dispatch('updateMapAxiosToken', { tokens: { calculateRouteAsidePoiSource: null } })
            reject(error)
          }
        )
      })
    },
    updateMapAxiosToken({ state, commit }, { tokens, isClear }) {
      if (isClear) {
        commit('SET_MAP_AXIOS_TOKEN', {})
      } else {
        let token = Object.assign({}, state.axiosToken, tokens)
        commit('SET_MAP_AXIOS_TOKEN', token)
      }
    },
    updateCenterPosition({ commit }, position) {
      commit('SET_CERTER_POSITION', position)
    },
    updateShowMarkerStatus({ commit }, status) {
      commit('SET_SHOW_MARKER_STATUS', status)
    },
    updateActivePointInfo({ commit }, info) {
      commit('SET_ACTIVE_POINT_INFO', info)
    },
    updateMapVisible({ commit }, status) {
      commit('SET_MAP_VISIBLE', status)
    },
    updateMapControlsDisabled({ commit }, status) {
      commit('SET_MAP_CONTROLS_DISABLED', status)
    },
    updateShowLoad({ commit, rootState }, status) {
      commit('SET_SHOW_LOAD', status)
      localStorage.setItem(`map_show_load_status_${rootState.user.userId}`, status)
    },
    updateShowDriver({ commit, rootState }, status) {
      commit('SET_SHOW_DRIVER', status)
      localStorage.setItem(`map_show_driver_status_${rootState.user.userId}`, status)
    },
    updateShowFuel({ commit }, status) {
      commit('SET_SHOW_FUEL', status)
    },
    updateCircleHidden({ commit }, status) {
      commit('SET_CIRCLE_HIDDEN', status)
    },
    updateActiveAsidePoi({ commit }, info) {
      commit('SET_ACTIVE_ASIDER_POI', info)
    },
    getAsidePouFuelPrice({ commit, state }) {
      getFuelPrice(state.poiOnRoute).then(pCt => {
        commit('SET_FUEL_PRICE_MAP', pCt)
      })
    }
  }
}

export default state
